import { Restaurant } from '@/shared/model/restaurant.model';
import { Marketer } from './../../model/marketer.model';
import { ISupportStore } from './types';

export const state: ISupportStore = {
  tab: 'dashboard',
  drawer: false,
  marketer: null,
  marketerDialog: false,
  newMarketer: new Marketer(),
  newMarketerDialog: false,
  restaurant: null,
  restaurantDialog: false,
  newRestaurant: new Restaurant(),
  newRestaurantDialog: false,
  support: null,
  supportDialog: false,
  unregisteredRestaurant: null,
  unregisteredRestaurantDialog: false,
  updatedRestaurant: null,
  updatedRestaurantDialog: false,
  unregisteredMarketer: null,
  unregisteredMarketerDialog: false,
};
